import React from 'react'
import contact from './image/contact.png'
import tele from './image/tel.png'
import { FaTelegram } from "react-icons/fa6"; 
import insta from './image/instagram.png'
import whats from './image/whatsapp.png'
import amout from './image/mail.png'
import { NavLink } from 'react-router-dom';


const Support = () => {
  return (
    <div>

        <div className='container'>
            <div className='row'>
            <div className='col-lg-7 col-sm-12 m-auto mt-5'>
                         
                         <div style={{display:'flex',  justifyContent:'center'}}>
                         <img src={contact}  style={{width:'80%'}}/>
                         </div>

                         <div className='mt-3 text-center'>
                            <strong>Contact us at below platforms.  </strong>
                              
                              <div> 


                                  <div className='mt-3 mb-4'  > 

                              <NavLink to="https://t.me/brothers_ludo7773"  style={{textDecoration:'none'}}>  <button className='btn teli w-100 ' style={{backgroundColor:'#0088cc'}}> <img src={tele}   style={{width:'10%'}}/>Connect on Telegram</button> </NavLink>
                                  </div>

                                  <div className='mt-3' style={{display:'flex', justifyContent:'center'}}> 

                                  <NavLink to="https://www.instagram.com/brothers_ludo?igsh=djZzbDN1ZHNsc3A2 " target='_blank' style={{textDecoration:'none'}}><button className='btn instagram'>  <img src={insta} style={{width:'10%'}}/>Connect on Instagram</button> </NavLink>
                                  </div>
 

                                  <div className='mt-3' style={{display:'flex', justifyContent:'center'}}> 
                              <NavLink to="https://whatsapp.com/channel/0029Vb25r3WHLHQR0FaJkO3v " target='_blank' style={{textDecoration:'none'}}>  <button className='btn what'>  <img src={whats} style={{width:'10%'}}/>Connect on WhatsApp</button></NavLink>
                                  
                                  </div>

                                  {/* <div className='mt-3' style={{display:'flex', justifyContent:'center'}}> 
                                <button className='btn what'>  <img src={amout} style={{width:'10%'}}/>Connect on Gmail</button>
                                  
                                  </div> */}
                                  {/* <h6 className='mt-2' style={{color:'#959595'}}>01234567899</h6> */}


                                  {/* <div className='mt-4' style={{display:'flex', justifyContent:'center'}}>
                              <img src={amout} style={{width:'15%'}}/>
                                  </div>
                                  <h6 className='mt-2' style={{color:'#959595'}}>01234567899</h6>
                                  <h6 className='mt-2' style={{color:'#959595'}}>rajasthani ludo</h6>
                                  <h6 className='mt-2' style={{color:'#959595'}}>Rajasthan, India</h6> */}

                              </div>
                         </div>



                         {/* <div className='mt-3 text-center'>
                            <h5>Current Earning:0 <span>Redeem</span> </h5>
                            <p>Total Earned:0</p>

                            <div style={{backgroundColor:'#e9ecef', height:'13px', borderRadius:'15px'}}>

                            </div>

                            <div style={{display:'flex', justifyContent:'space-between'}}>
                                <p>Max: ₹10,000</p>
                                <p>Upgrade Limit</p>
                            </div>

                            <div>
                                <strong className='text-center'>Your Refer Code: 408890</strong>
                                <h6 className='text-center'>Total Refers:0</h6>
                            </div>



                            
                         </div> */}
                </div>
            </div>
        </div>
    </div>
  )
}

export default Support